<template>
  <div class="page-stack">
    <section class="provider-grid">
      <article v-for="provider in items" :key="`${provider.providerCode}-${provider.environment}`" class="provider-card surface-card">
        <div class="provider-card-head">
          <div class="provider-logo"><i class="el-icon-phone-outline"></i></div>
          <div>
            <p class="eyebrow">VOICE PROVIDER</p>
            <h3>{{ provider.providerCode }}</h3>
          </div>
          <span :class="['simple-state', provider.enabled ? 'on' : 'off']">
            {{ provider.enabled ? '已启用' : '安全停用' }}
          </span>
        </div>
        <dl class="provider-details">
          <div><dt>环境</dt><dd>{{ provider.environment }}</dd></div>
          <div><dt>Endpoint</dt><dd class="mono">{{ provider.endpointMasked || '未配置' }}</dd></div>
          <div>
            <dt>凭据</dt>
            <dd><i :class="provider.credentialsConfigured ? 'el-icon-success ok' : 'el-icon-warning warn'"></i>
              {{ provider.credentialsConfigured ? '已安全配置' : '未配置' }}
            </dd>
          </div>
          <div><dt>连通性</dt><dd><status-tag :status="provider.connectivityStatus" /></dd></div>
          <div><dt>更新时间</dt><dd>{{ formatDate(provider.updatedAt) }}</dd></div>
        </dl>
        <div class="provider-actions">
          <el-button disabled>查看配置</el-button>
          <el-tooltip content="刷新网关已采集的连通性状态，不会向供应商发起真实呼叫" placement="top">
            <el-button type="primary" plain :loading="refreshing" @click="refreshConnectivity">刷新连通性状态</el-button>
          </el-tooltip>
        </div>
      </article>
    </section>

    <el-empty v-if="!loading && !items.length" description="尚未配置供应商" />
  </div>
</template>

<script>
import { getProviders } from '../api/admin'
import StatusTag from '../components/StatusTag.vue'

export default {
  name: 'ProviderView',
  components: { StatusTag },
  data () {
    return { loading: true, refreshing: false, items: [] }
  },
  async created () {
    await this.loadProviders()
  },
  methods: {
    async loadProviders () {
      try {
        this.items = await getProviders()
      } catch (error) {
        this.$message.error('供应商状态加载失败')
      } finally {
        this.loading = false
      }
    },
    async refreshConnectivity () {
      this.refreshing = true
      try {
        this.items = await getProviders()
        this.$message.success('连通性状态已刷新；当前版本不执行供应商主动探测')
      } catch (error) {
        this.$message.error('连通性状态刷新失败')
      } finally {
        this.refreshing = false
      }
    },
    formatDate (value) {
      return value ? value.replace('T', ' ') : '—'
    }
  }
}
</script>

